import { ArrowForwardIos } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import clsx from "clsx";
import { FC } from "react";
import { useTranslation } from "react-i18next";

import { useRtl } from "@ryde/redux";

import { ContinueButtonStyled } from "./continue-button.styled";

export interface IContinueButton {
  onClick: () => void;
  content?: string;
  disabled?: boolean;
  loading?: boolean;
}

export const ContinueButton: FC<IContinueButton> = ({
  onClick,
  content,
  disabled = false,
  loading,
}) => {
  const { t } = useTranslation();
  const { isRtl } = useRtl();
  const buttonContent = content || t("general.CONTINUE");

  return (
    <ContinueButtonStyled
      variant="contained"
      size="large"
      onClick={onClick}
      disabled={disabled || loading}
      className="continue-button"
    >
      <span className="button-content">
        <span className="button-label">
          {loading ? (
            <CircularProgress sx={{ color: "inherit" }} size={16} />
          ) : (
            buttonContent
          )}
        </span>
        <ArrowForwardIos className={clsx("button-icon", { isRtl })} />
      </span>
    </ContinueButtonStyled>
  );
};
